import React from 'react';
import './ResetPassword.scss';
import toast, { Toaster } from 'react-hot-toast';
import { resetPasswordValidation } from '../../helper/validate';
import { resetPassword, updateFirstLoginStatus } from '../../helper/helper';
import { useAuthStore } from '../../store/store';
import { useNavigate, Navigate } from 'react-router-dom';
import useFetch from '../../hooks/fetch.hook';
import ChangePasswordUI from '../ChangePassword/ChangePasswordUI';
import RecoverySideBar from '../ui/SideBanner';

const ResetPassword = () => {
  const { username } = useAuthStore((state) => state.auth);
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [{ isLoading, apiData, status, serverError }] = useFetch('createResetSession');

  const handleSubmit = async (values) => {

    const validationErrors = await resetPasswordValidation(values);
    if (Object.keys(validationErrors).length > 0) {
      return; // Return early if there are validation errors
    }
    let resetPromise = resetPassword({ username, password: values.newPass });
    toast.loading('Updating...', {
      id: 'resetPasswordToast',
    });

    resetPromise
      .then(() => {
        toast.success(<b>Reset Successfully...!</b>, {
          id: 'resetPasswordToast',
        });
        return navigate('/');
      })
      .catch(() => {
        toast.error(<b>Could not Reset!</b>, {
          id: 'resetPasswordToast',
        });
      });

    resetPromise.then(() => {
      let firstLoginPromise = updateFirstLoginStatus({ username });
      firstLoginPromise
        .then(function () {
          return navigate('/');
        })
        .catch(function (error) {
          console.error('Error updating first login status:', error);
        });
    });
  };

  if (isLoading) return <h1 className="text-2xl font-bold">isLoading</h1>;
  // if (serverError) return <h1 className="text-xl text-red-500">{serverError.message}</h1>;
  if (status && status !== 201) return <Navigate to={'/password'} replace={true}></Navigate>;
  return (
    <div className="wrapper-reset-pass">
      <RecoverySideBar />
      <div className="reset-container">
        <Toaster
          position="top-center"
          reverseOrder={false}
          gutter={4}
          toastOptions={{ duration: 3000 }}
        />

        <div className="reset-block">
          <ChangePasswordUI
            handleSubmit={handleSubmit}
            hideOldPass
            styles={{
              container: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgb(248, 247, 247)',
              },
              formContainer: { height: '100%', borderRadius: '0' },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
